import useStateStore from 'services/store';
import './shirt-collar.scss';

const collarSize = [
  {
    id: '13',
    size: '13"',
  },
  {
    id: '13/2',
    size: '13 ½"',
  },
  {
    id: '14',
    size: '14"',
  },
  {
    id: '14/2',
    size: '14 ½"',
  },
  {
    id: '15',
    size: '15"',
  },
  {
    id: '15/2',
    size: '15 ½"',
  },
  {
    id: '16',
    size: '16"',
  },
  {
    id: '16/2',
    size: '16 ½"',
  },
  {
    id: '17',
    size: '17"',
  },
  {
    id: '17/2',
    size: '17 ½"',
  },
  {
    id: '18',
    size: '18"',
  },
  {
    id: '18/2',
    size: '18 ½"',
  },
  {
    id: '19',
    size: '19"',
  },
  {
    id: '19/2',
    size: '19 ½"',
  },
  {
    id: '20',
    size: '20"',
  },
  {
    id: '20/2',
    size: '20 ½"',
  },
  {
    id: '21',
    size: '21"',
  },
  {
    id: '21/2',
    size: '21 ½"',
  },
  {
    id: '22',
    size: '22"',
  },
  {
    id: '22/2',
    size: '22 ½"',
  },
  // {
  //   id: 2,
  //   size: '13 ½"',
  // },
  // {
  //   id: 3,
  //   size: '14"',
  // },
  // {
  //   id: 4,
  //   size: '14 ½"',
  // },
  // {
  //   id: 5,
  //   size: '15"',
  // },
  // {
  //   id: 6,
  //   size: '15 ½"',
  // },
  // {
  //   id: 7,
  //   size: '16"',
  // },
  // {
  //   id: 8,
  //   size: '16 ½"',
  // },
  // {
  //   id: 9,
  //   size: '17"',
  // },
  // {
  //   id: 10,
  //   size: '17 ½"',
  // },
  // {
  //   id: 11,
  //   size: '18"',
  // },
  // {
  //   id: 12,
  //   size: '18 ½"',
  // },
  // {
  //   id: 13,
  //   size: '19"',
  // },
  // {
  //   id: 14,
  //   size: '19 ½"',
  // },
  // {
  //   id: 15,
  //   size: '20"',
  // },
  // {
  //   id: 16,
  //   size: '20 ½"',
  // },
  // {
  //   id: 17,
  //   size: '21"',
  // },
  // {
  //   id: 18,
  //   size: '21 ½"',
  // },
  // {
  //   id: 19,
  //   size: '22"',
  // },
  // {
  //   id: 20,
  //   size: '22 ½"',
  // },
];

const ShirtCollar = () => {
  const { inforStepValues: steps, changeInforStepValues } = useStateStore();
  const handleChangeSteps = (id: string) => {
    changeInforStepValues('collar-size', id);
  };

  return (
    <div className="body-container">
      <div className="infor">
        <div className="title">SHIRT COLLAR SIZE</div>
        <div className="confirm">
          What collar size do you usually prefer when buying dress shirts?
        </div>
      </div>
      <div className="text-options">
        {collarSize.map((size) => (
          <div
            onClick={() => handleChangeSteps(size.id)}
            key={size.id}
            className={`text-option ${
              steps['collar-size'] === size.id ? 'active' : ''
            }`}
          >
            {size.size}
          </div>
        ))}
      </div>
      <div
        className={`dont-know ${steps['collar-size'] === '' ? 'active' : ''}`}
      >
        <div onClick={() => handleChangeSteps('')} className="dont-know-btn">
          I don't know
        </div>
      </div>
    </div>
  );
};

export default ShirtCollar;
